import { colord, extend, LchColor } from "colord";
import lchPlugin from "colord/plugins/lch";
import { linspace, shuffleWithSeed } from "./random";
extend([lchPlugin]);

/**
 * Set of colors corresponding to the same hue, with different lightness
 * (keys of 100-800 to match tailwind styles)
 */
export interface Hue<T> {
  100: T;
  200: T;
  300: T;
  600: T;
  700: T;
  800: T;
}

/**
 * Generates a hue with different lightness (keys of 100-800 to match tailwind styles),
 * given a hue in the LCH color space.
 */
export const getHue = (hue: number): Hue<LchColor> => {
  // Generated by inserting existing green variants' hex value into https://css.land/lch/
  // and copying the L and C values.
  return {
    100: { l: 98, c: 6, h: hue },
    200: { l: 96, c: 22, h: hue },
    300: { l: 92, c: 40, h: hue },
    600: { l: 75, c: 94, h: hue },
    700: { l: 65, c: 85, h: hue },
    800: { l: 58, c: 73, h: hue },
  };
};

/** Gets `num` colors equally spaced across the hue range in the LCH color space. */
export const getHues = (num: number): Hue<LchColor>[] => {
  return shuffleWithSeed(
    linspace(0, 360, num, false).map((hue) => getHue(hue)),
    42,
  ); // Seeded shuffle so labels are not colored in rainbow (roygbiv) order.
};

export const colorToString = (color: LchColor): string => {
  return colord(color).toHex();
};
